// Sprint monitor-tool-live-timer — 1 Hz elapsed-ms ticker.
//
// Each mount holds its own `setInterval`; the cost is negligible (a
// handful of in-flight tool rows in a worst-case turn). A shared
// interval would couple the lifecycle of unrelated rows for no real
// gain — the spec explicitly trades that complexity for one interval
// per mount (D8).
//
// `startedAtMs` is wall-clock (`Date.now()` of the tool_use), so the
// timer survives reload — the next mount reads back the same anchor
// from the persisted Message timestamp.

import { useEffect, useState } from 'react';

export function useElapsed(startedAtMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  return Math.max(0, now - startedAtMs);
}
